import angular from 'angular';

import ViewAdminAccountController from './view-admin-account-controller';

const viewAdminAccount = angular.module('viewAdminAccount', []);
viewAdminAccount.controller('ViewAdminAccountController', ViewAdminAccountController);

export default viewAdminAccount.name;
